import { v4 as uuidv4 } from 'uuid';
import { PKCEState } from './types/OAuthProvider';
import sha256 from './sha256';

const PKCE_STATE_KEY = 'pkcestate';

export class PKCE {
  protected pkce: PKCEState | undefined = undefined;
  constructor() {
    this.load();
  }

  async initialize(): Promise<void> {
    if (this.pkce) {
      return;
    }

    await this.create();
  }

  private async create(): Promise<PKCEState> {
    const state = uuidv4();
    const verifier = uuidv4();

    const hash = await sha256(verifier);

    localStorage.setItem(
      PKCE_STATE_KEY,
      JSON.stringify({
        state: state,
        code_verifier: verifier,
        code_challenge: hash
      } as PKCEState)
    );

    return this.load() as PKCEState;
  }

  private load(): PKCEState | undefined {
    const state = localStorage.getItem(PKCE_STATE_KEY);

    if (!state) {
      return undefined;
    }

    this.pkce = JSON.parse(state) as PKCEState;

    return this.pkce;
  }

  protected pkceClear(): void {
    this.pkce = undefined;
    localStorage.removeItem(PKCE_STATE_KEY);
  }
}
